import { ProductDetailInterface } from "../../interfaces/apiV2/product/ProductDetailInterface";
import { ProductGroupedDownloadItemInterface } from "../../interfaces/apiV2/product/ProductDownloadsInterface";
import { hasProductDownloadContent } from "./buildProductDownloadEntries";

const isProductDetailSectionPending = (
    isPageLoading: boolean,
    translationsLoaded: boolean,
): boolean => isPageLoading || !translationsLoaded;

const hasGeneralInformation = (data?: ProductDetailInterface): boolean =>
    !!data?.description?.value;

const hasSpecifications = (data?: ProductDetailInterface): boolean =>
    !!data?.dimensions ||
    (data?.productAttributes?.length ?? 0) > 0 ||
    (data?.beverages?.length ?? 0) > 0;

export const showSpecificationInfoSection = (
    data: ProductDetailInterface | undefined,
    isPageLoading: boolean,
    translationsLoaded: boolean,
): boolean =>
    isProductDetailSectionPending(isPageLoading, translationsLoaded) ||
    hasGeneralInformation(data) ||
    hasSpecifications(data);

export const showProductSlidersSection = (
    isPageLoading: boolean,
    translationsLoaded: boolean,
    isAssociationsLoading: boolean,
    accessoriesCount: number,
    similarProductsCount: number,
    addOnsCount: number,
): boolean =>
    isProductDetailSectionPending(isPageLoading, translationsLoaded) ||
    isAssociationsLoading ||
    accessoriesCount > 0 ||
    similarProductsCount > 0 ||
    addOnsCount > 0;

const hasProductDownloads = (
    marketingDownloads: Record<string, ProductGroupedDownloadItemInterface[]>,
    technicalDownloads: Record<string, ProductGroupedDownloadItemInterface[]>,
    marketingDownloadsCount: number,
    technicalDownloadsCount: number,
): boolean =>
    marketingDownloadsCount > 0 ||
    technicalDownloadsCount > 0 ||
    hasProductDownloadContent(marketingDownloads) ||
    hasProductDownloadContent(technicalDownloads);

export const showDownloadsSection = (
    isPageLoading: boolean,
    downloadsLoading: boolean,
    translationsLoaded: boolean,
    marketingDownloads: Record<string, ProductGroupedDownloadItemInterface[]>,
    technicalDownloads: Record<string, ProductGroupedDownloadItemInterface[]>,
    marketingDownloadsCount: number,
    technicalDownloadsCount: number,
): boolean =>
    !isPageLoading &&
    !downloadsLoading &&
    translationsLoaded &&
    hasProductDownloads(
        marketingDownloads,
        technicalDownloads,
        marketingDownloadsCount,
        technicalDownloadsCount,
    );

export const showOlderModelsSection = (
    translationsLoaded: boolean,
    olderModelsCount: number,
): boolean => translationsLoaded && olderModelsCount > 0;

export const showProductCarouselSection = (
    isLoading: boolean,
    imageCount: number,
): boolean => isLoading || imageCount > 0;
